import { useQuery } from "@tanstack/react-query";
import { getLessonDetails } from "../../../api/endpoints/LessonEndpoints";
import { useCallback } from "react";

export default function useGetLessonDetails(lessonId: string) {
  const getLessonDetailsFn = useCallback(() => {
    return getLessonDetails(lessonId);
  }, [lessonId]);

  return useQuery({
    queryKey: ["lesson", lessonId],
    queryFn: getLessonDetailsFn,
  });
}
